import React from 'react';
import { Reveal } from './Reveal';
import { transformationStats } from '../data/transformation';
export function TransformationSection() {
  return <section className="bg-white px-4 py-16 md:py-24" data-id="element-207" data-mp="31xicmqebhih6">
      <Reveal className="mx-auto max-w-4xl text-center" data-id="element-208" data-mp="2wwuk20afwtku">
        <p className="mb-4 font-note text-[10px] font-semibold tracking-[0.24em] text-sage sm:text-xs" data-id="element-209" data-mp="2wzgtk5gw5j5p">
          UN MODO PIÙ SERENO DI INSEGNARE
        </p>
        <h2 className="text-3xl font-bold leading-[1.15] tracking-tight text-petrol md:text-[2.75rem]" data-id="element-210" data-mp="2nxqzervmk648">
          Da lezioni improvvisate a un <span className="italic text-sage" data-id="element-211" data-mp="2j462z49ojk75">metodo</span> che si vede.
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-muted md:text-base" data-id="element-212" data-mp="2e7flqdm52ik5">
          Ogni istruttrice di Reformer conosce quella sensazione: aprire il quaderno la sera prima, rimettere insieme
          esercizi presi qua e là, sperare che la classe segua. Pilates Reformer Pronto toglie di mezzo tutto questo e
          ti lascia solo la parte che conta davvero: insegnare bene, con presenza e con calma.
        </p>
        <div className="mx-auto mt-12 grid max-w-3xl gap-4 sm:grid-cols-3" data-id="element-213" data-mp="k1ixwto7dl1l">
          {transformationStats.map(([value, label]) => <div key={label} className="rounded-xl border border-line bg-sand px-5 py-6 text-center shadow-soft" data-id="element-214" data-mp="5e7mcrs0u11h">
              <strong className="block font-heading text-3xl font-bold leading-none text-terracotta" data-id="element-215" data-mp="acituvuufzgj">{value}</strong>
              <span className="mt-2.5 block font-note text-[10px] font-semibold leading-tight tracking-[0.1em] text-muted" data-id="element-216" data-mp="xzh7zmvhqvba">
                {label}
              </span>
            </div>)}
        </div>
      </Reveal>
    </section>;
}